import { __assign, __rest, __spreadArray } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Icon, { IconColors } from './Icon';
import Loader from './Loader';
import { ICON_TYPES } from './iconTypes';
import './ButtonBase.scss';
export var ButtonSizes = { SMALL: 'small', MEDIUM: 'medium' };
export var ButtonTypes = {
    DESTROY: 'destroy',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var ButtonBase = function (_a) {
    var _b;
    var buttonType = _a.buttonType, className = _a.className, count = _a.count, dataTestId = _a["data-testid"], icon = _a.icon, iconColor = _a.iconColor, isDarkMode = _a.isDarkMode, isDisabled = _a.isDisabled, isFullWidth = _a.isFullWidth, isLoading = _a.isLoading, isOutline = _a.isOutline, label = _a.label, onClick = _a.onClick, size = _a.size, type = _a.type, url = _a.url, props = __rest(_a, ["buttonType", "className", "count", 'data-testid', "icon", "iconColor", "isDarkMode", "isDisabled", "isFullWidth", "isLoading", "isOutline", "label", "onClick", "size", "type", "url"]);
    var buttonClassName = classnames('Button', className, "Button--".concat(size), (_b = {
            'Button--primary': type === ButtonTypes.PRIMARY && !isOutline,
            'Button--primaryOutline': type === ButtonTypes.PRIMARY && isOutline && !isDarkMode,
            'Button--primaryOutlineDarkMode': type === ButtonTypes.PRIMARY && isOutline && isDarkMode,
            'Button--secondary': type === ButtonTypes.SECONDARY,
            'Button--secondaryNoOutline': type === ButtonTypes.SECONDARY && !isOutline,
            'Button--destroy': type === ButtonTypes.DESTROY
        },
        _b["Button--hasIconOnly"] = !label,
        _b['Button--isDisabled'] = isDisabled,
        _b['Button--isFullWidth'] = isFullWidth && label,
        _b['Button--isLoading'] = isLoading,
        _b));
    var handleClick = function () {
        /* istanbul ignore else */
        if (onClick) {
            onClick();
        }
    };
    var getTestId = function () { return dataTestId || "".concat(label || icon, " button"); };
    var getContent = function () { return (React.createElement(React.Fragment, null,
        icon ? (React.createElement(Icon, { className: 'Button__icon', color: iconColor, size: size, type: icon })) : null,
        label && React.createElement("span", { className: 'Button__label' }, label),
        !icon && Number.isFinite(count) && (React.createElement("span", { className: 'Button__badge' }, count)),
        isLoading && (React.createElement(Loader, { className: 'Button__loader', isDarkMode: type === ButtonTypes.PRIMARY && !isOutline, size: 'small' })))); };
    /* eslint-disable react/button-has-type */
    // Disabling rule because `type` prop must be more strictly
    // enforced and the work to do so is beyond the scope of
    // THRIVE-8639
    var getButton = function () { return (React.createElement("button", __assign({}, props, { className: buttonClassName, "data-testid": getTestId(), disabled: isDisabled, onClick: handleClick, type: buttonType }), getContent())); };
    /* eslint-enable react/button-has-type */
    var getLink = function () { return (React.createElement("a", __assign({}, props, { className: buttonClassName, "data-testid": getTestId(), href: url || '#' }), getContent())); };
    return url ? getLink() : getButton();
};
ButtonBase.defaultProps = {
    buttonType: 'button',
    /**
     * Setting default iconColor to 'inherit' to make sure default color value on icon does not
     * take over.  This allows each button type to control the color of the icon via SCSS
     */
    iconColor: 'inherit',
    isDarkMode: false,
    isDisabled: false,
    isFullWidth: false,
    isLoading: false,
    isOutline: false,
    onClick: function () { },
    size: ButtonSizes.MEDIUM
};
export var SharedButtonBasePropTypes = {
    buttonType: PropTypes.oneOf(['button', 'submit']),
    className: PropTypes.string,
    count: PropTypes.number,
    icon: PropTypes.oneOf(ICON_TYPES),
    iconColor: PropTypes.oneOf(__spreadArray(__spreadArray([], Object.values(IconColors), true), ['inherit'], false)),
    isDarkMode: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    isOutline: PropTypes.bool,
    label: PropTypes.node,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(Object.values(ButtonSizes)),
    url: PropTypes.string
};
var ButtonBasePropTypes = __assign(__assign({}, SharedButtonBasePropTypes), { type: PropTypes.oneOf(Object.values(ButtonTypes)).isRequired });
ButtonBase.propTypes = ButtonBasePropTypes;
export default ButtonBase;
//# sourceMappingURL=ButtonBase.js.map